var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","aria-label":"Navbar toggle button"}},[_c('span',{staticClass:"navbar-toggler-bar bar1"}),_c('span',{staticClass:"navbar-toggler-bar bar2"}),_c('span',{staticClass:"navbar-toggler-bar bar3"})])
}]

export { render, staticRenderFns }